import React, { useState, useEffect, useRef } from 'react'
import ModalHeader from './ModalHeader'
import ModalContent from './ModalContent'

const MediaModal = ({
  selectedMedia,
  isClearTheme,
  isOwner,
  editingName,
  editingDescription,
  newName,
  newDescription,
  loading,
  onClose,
  onStartEditName,
  onStartEditDescription,
  onSaveName,
  onSaveDescription,
  onCancelEdit,
  onSetNewName,
  onSetNewDescription,
  onDeleteMedia,
  onEditPhoto
}) => {
  const [isMobile, setIsMobile] = useState(false)
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const [isDragging, setIsDragging] = useState(false)
  const dragStartRef = useRef({ x: 0, y: 0 })

  useEffect(() => {
    const checkMobile = () => {
      const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
                     window.innerWidth < 768
      setIsMobile(mobile)
    }
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isDragging) return
      e.preventDefault()
      setPosition({
        x: e.clientX - dragStartRef.current.x,
        y: e.clientY - dragStartRef.current.y
      })
    }

    const handleMouseUp = () => {
      if (isDragging) {
        setIsDragging(false)
        document.body.style.cursor = ''
        document.body.style.userSelect = ''
      }
    }

    if (isDragging) {
      document.body.style.cursor = 'move'
      document.body.style.userSelect = 'none'
      window.addEventListener('mousemove', handleMouseMove)
      window.addEventListener('mouseup', handleMouseUp)
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove)
      window.removeEventListener('mouseup', handleMouseUp)
    }
  }, [isDragging])

  const handleDragStart = (e) => {
    e.preventDefault()
    setIsDragging(true)
    dragStartRef.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y
    }
  }

  if (!selectedMedia) return null

  return (
    <div className={`fixed inset-0 z-40 flex items-center justify-center p-4 ${
      isMobile
        ? 'bg-black/80'
        : isClearTheme
          ? 'bg-black/30 backdrop-blur-lg'
          : 'bg-black/80'
    }`}>
      <div
        className={`rounded-2xl max-w-4xl max-h-[90vh] w-full overflow-hidden ${
          isClearTheme ? 'bg-white text-gray-900' : 'bg-gray-900 text-white'
        }`}
        style={{
          transform: `translate(${position.x}px, ${position.y}px)`,
          position: 'relative'
        }}
      >
        <div
          className="cursor-move"
          onMouseDown={handleDragStart}
        >
          <ModalHeader
            selectedMedia={selectedMedia}
            isOwner={isOwner}
            editingName={editingName}
            newName={newName}
            loading={loading}
            onClose={onClose}
            onStartEditName={onStartEditName}
            onSaveName={onSaveName}
            onCancelEdit={onCancelEdit}
            onSetNewName={onSetNewName}
            isClearTheme={isClearTheme}
          />
        </div>

        <ModalContent
          selectedMedia={selectedMedia}
          isOwner={isOwner}
          editingDescription={editingDescription}
          newDescription={newDescription}
          loading={loading}
          onStartEditDescription={onStartEditDescription}
          onSaveDescription={onSaveDescription}
          onCancelEdit={onCancelEdit}
          onSetNewDescription={onSetNewDescription}
          onDeleteMedia={onDeleteMedia}
          onEditPhoto={onEditPhoto}
          isClearTheme={isClearTheme}
        />
      </div>
    </div>
  )
}

export default MediaModal